import React from "react"
import Header from "./Header/Header"
import CustomSidebar from "./CustomSidebar/CustomSidebar"
import { Box } from "@mui/material"

export function MainLayout({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{ display: "grid", maxWidth: 1575, width: "100%", margin: "auto" }}
    >
      <Header />
      <Box sx={{ display: "flex", background: "#F4F4F4" }}>
        <Box
          sx={{
            display: "flex",
            position: "relative",
            top: "14px",
            left: "10px",
            background: "#F4F4F4",
            borderRadius: "12px",
          }}
        >
          <CustomSidebar />
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "grid",
            background: "#F4F4F4",
            flexGrow: 7,
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  )
}
